import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAiRequestType implements BaseEnumType {
  private static allValues: EnumAiRequestType[] = []; // make sure this is top-most
  
  public static salesBriefing = new EnumAiRequestType(0, "SalesBriefing", "enum_ai_request_type_sales_briefing");
  public static orderSuggestion = new EnumAiRequestType(1, "OrderSuggestion", "enum_ai_request_type_order_suggestion");
  public static purchaseOrderDeliveryNoteScan = new EnumAiRequestType(2, "PurchaseOrderDeliveryNoteScan", "enum_ai_request_type_purchase_order_delivery_note_scan");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAiRequestType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isSalesBriefing() { return this === EnumAiRequestType.salesBriefing; }
  public isOrderSuggestion() { return this === EnumAiRequestType.orderSuggestion; }
  public isPurchaseOrderDeliveryNoteScan() { return this === EnumAiRequestType.purchaseOrderDeliveryNoteScan; }

  public static getValues(): readonly EnumAiRequestType[] {
    return EnumAiRequestType.allValues;
  }

  public static getValuesExcept0(): readonly EnumAiRequestType[] {
    return EnumAiRequestType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAiRequestType {
    const found = EnumAiRequestType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAiRequestType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAiRequestType): EnumAiRequestType {
    const found = name ? EnumAiRequestType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAiRequestType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAiRequestType>): boolean {
    return this.key === other?.key;
  }
}